// extracted by mini-css-extract-plugin
module.exports = {"status":"CaseStatusColumn_status__19JQr","red":"CaseStatusColumn_red__2oJbn","yellow":"CaseStatusColumn_yellow__3iBju","grey":"CaseStatusColumn_grey__1yo6Z"};